import type { HelpLanguage } from '../../i18n/help';
import type { KnowledgeArticleTranslations } from './articles.types';
import { KNOWLEDGE_BASE_ARTICLES_AR } from './articles.ar';
import { KNOWLEDGE_BASE_ARTICLES_UR } from './articles.ur';
import { KNOWLEDGE_BASE_ARTICLES_HI } from './articles.hi';
import { KNOWLEDGE_BASE_ARTICLES_BN } from './articles.bn';
import { KNOWLEDGE_BASE_ARTICLES_SI } from './articles.si';
import { KNOWLEDGE_BASE_ARTICLES_NE } from './articles.ne';

/**
 * Knowledge Base article translations keyed by language. English is the source
 * (it lives in `constants/knowledgeBaseArticles.ts`), so it is intentionally
 * absent here — `getKnowledgeArticleTranslations` returns `undefined` for `en`
 * (and any unsupported language), which signals the source article should be
 * used as-is.
 */
const KNOWLEDGE_BASE_ARTICLE_TRANSLATIONS: Partial<
  Record<HelpLanguage, KnowledgeArticleTranslations>
> = {
  ar: KNOWLEDGE_BASE_ARTICLES_AR,
  ur: KNOWLEDGE_BASE_ARTICLES_UR,
  hi: KNOWLEDGE_BASE_ARTICLES_HI,
  bn: KNOWLEDGE_BASE_ARTICLES_BN,
  si: KNOWLEDGE_BASE_ARTICLES_SI,
  ne: KNOWLEDGE_BASE_ARTICLES_NE,
};

export const getKnowledgeArticleTranslations = (
  language: string
): KnowledgeArticleTranslations | undefined =>
  KNOWLEDGE_BASE_ARTICLE_TRANSLATIONS[language.split('-')[0] as HelpLanguage];
